// Simple EN/RO translation dictionary
const dict = {
  en: {
    // Nav
    dashboard: "Dashboard",
    patients: "Patients",
    reports: "Reports",
    settings: "Settings",
    appointments: "Appointments",
    invoices: "Invoices",
    analytics: "Analytics",
    ownerPortal: "Owner portal",
    logout: "Log out",
    // Auth
    signIn: "Sign in",
    signInHint: "Enter your credentials to access your clinic workspace.",
    email: "Email",
    password: "Password",
    signingIn: "Signing in…",
    demoCredentials: "Try the demo:",
    forgotPassword: "Forgot your password?",
    noAccountYet: "Don't have an account?",
    createAccount: "Sign up",
    signingUp: "Signing up…",
    fullName: "Full name",
    passwordMinChars: "Minimum 6 characters",
    registerSuccessTitle: "Check your inbox",
    registerSuccessBody: "We sent a confirmation link to your email address. Click it to verify, then wait for the administrator to assign your role and clinic.",
    verifyingEmail: "Verifying your email…",
    emailVerifiedTitle: "Email verified",
    emailVerifiedBody: "Your account is now waiting for an administrator to assign your role and clinic. You'll receive an email when it's ready.",
    emailVerifyFailedTitle: "Verification failed",
    backToLogin: "Back to login",
    resendVerification: "Resend verification email",
    registerClinic: "Register your clinic",
    // Dashboard
    goodEvening: "Welcome back",
    searchPlaceholder: "Search by patient, owner, or phone…",
    searchHint: "Press ⌘K anywhere",
    quickActions: "Quick actions",
    newPatient: "New patient",
    newConsultation: "New consultation",
    selectPatientForConsult: "Search and select the patient for this consultation.",
    exportConsults: "Export consultations",
    recentPatients: "Recent patients",
    recentConsultations: "Recent consultations",
    metricPatients: "Patients on file",
    metricConsultsToday: "Consultations this week",
    metricPendingDrafts: "Draft consultations",
    // Patient
    owner: "Owner",
    species: "Species",
    breed: "Breed",
    sex: "Sex",
    birthDate: "Birth date",
    neutered: "Neutered",
    age: "Age",
    consultations: "Consultations",
    attachments: "Attachments",
    addAttachment: "Add attachment",
    deletePatient: "Delete patient",
    // Consultation
    visitReasons: "Visit reasons",
    privateNotes: "Private notes (not shared)",
    anamnesis: "History / Anamnesis",
    consultationReport: "Consultation Report",
    view: "View",
    clinicalExamination: "Clinical examination",
    generalExam: "General examination",
    temperature: "Temperature",
    weight: "Weight",
    clinicalExam: "Clinical examination",
    labInvestigations: "Laboratory investigations",
    biochemistry: "Biochemistry",
    cbc: "Complete Blood Count",
    parameter: "Parameter",
    result: "Result",
    unit: "Unit",
    referenceRange: "Reference range",
    diagnosis: "Diagnosis",
    treatment: "Treatment",
    recommendations: "Recommendations",
    attendingVet: "Attending veterinarian",
    autosave: "Draft autosaved",
    saving: "Saving…",
    save: "Save",
    saveFinal: "Save as final",
    downloadPdf: "Download PDF",
    emailOwner: "Email owner",
    delete: "Delete",
    cancel: "Cancel",
    translateFieldsRo: "Translate to Romanian",
    translateFieldsEn: "Translate to English",
    translating: "Translating…",
    // Reports
    filters: "Filters",
    dateFrom: "From",
    dateTo: "To",
    veterinarian: "Veterinarian",
    all: "All",
    exportXlsx: "Export .xlsx",
    // Invoices
    invoiceNumber: "#",
    invoiceStatus: "Status",
    invoiceIssued: "Issued",
    dueDate: "Due date",
    undiagnosedYet: "Undiagnosed yet",
    invoiceTotal: "Total",
    newInvoice: "New invoice",
    invoiceStatusDraft: "Draft",
    invoiceStatusUnpaid: "Unpaid",
    invoiceStatusSent: "Sent",
    invoiceStatusPaid: "Paid",
    invoiceStatusVoid: "Void",
    description: "Description",
    qty: "Qty",
    unitPrice: "Unit price (VAT incl.)",
    taxPct: "Tax %",
    currency: "Currency",
    subtotal: "Subtotal",
    tax: "Tax",
    createInvoice: "Create invoice",
    markPaid: "Mark paid",
    voidInvoice: "Void",
    noInvoices: "No invoices yet.",
    // Settings
    clinicProfile: "Clinic profile",
    users: "Users",
    pendingUsers: "Pending users",
    noPendingUsers: "No pending users.",
    approve: "Approve",
    reject: "Reject",
    approveUser: "Approve user",
    userApproved: "User approved.",
    userRejected: "User rejected.",
    confirmReject: "Reject this user?",
    selectClinic: "Select a clinic.",
    clinic: "Clinic",
    actions: "Actions",
    customVisitReasons: "Custom visit reasons",
    referenceRanges: "Reference ranges",
    cui: "Tax ID (CUI/VAT)",
    regCom: "Trade Registry",
    iban: "IBAN",
    bankName: "Bank",
    invoiceSeries: "Invoice series",
    // Common
    addRow: "Add row",
    remove: "Remove",
    yes: "Yes",
    no: "No",
    male: "Male",
    female: "Female",
    dog: "Dog",
    cat: "Cat",
    other: "Other",
    role: "Role",
    admin: "Administrator",
    veterinarianRole: "Veterinarian",
    assistant: "Assistant",
    name: "Name",
    phone: "Phone",
    address: "Address",
    saved: "Saved",
    saveClinicInfo: "Save clinic info",
    logo: "Logo",
    uploadLogo: "Upload logo",
    replaceLogo: "Replace logo",
    minValue: "Min",
    maxValue: "Max",
    category: "Category",
    fullName: "Full name",
    createPatient: "Create patient",
    createUser: "Create user",
    addReason: "Add reason",
    saveRefRanges: "Save reference ranges",
    noResults: "No results yet.",
    createFirst: "Create your first record to get started.",
    weekOf: "Week of",
    monthView: "Month",
    weekView: "Week",
    dayView: "Day",
    today: "Today",
    newAppointment: "New appointment",
    reason: "Reason",
    dateTime: "Date & time",
    schedule: "Schedule",
    noAppointments: "No appointments",
    completed: "Done",
    noShow: "No-show",
    speciesLabel: "Species",
    speciesCustomPlaceholder: "Type a species (e.g. rabbit, parrot)",
    // Consultation attachments
    consultAttachments: "Consultation attachments",
    consultAttachmentsHint: "Files here belong to this consultation only.",
    uploadFiles: "Upload files",
    uploading: "Uploading…",
    dropOrClick: "Drop files here or click to browse",
    fileTypes: "Images (JPEG, PNG) and PDFs, up to 25MB each.",
    // Diagnoses
    searchOrCreateDiagnosis: "Search or create a diagnosis…",
    createDiagnosis: "Create diagnosis",
    diagnosisNotes: "Diagnosis notes (free text)",
    selectedDiagnoses: "Selected diagnoses",
    filterDiagnosis: "Diagnosis",
    diagnosisStats: "Diagnosis statistics",
    groupBy: "Group by",
    groupByDiagnosis: "By diagnosis",
    groupByMonth: "By month",
    groupBySpecies: "By species",
    groupByVet: "By veterinarian",
    totalCases: "Total cases",
    // Billing
    proceduresAndProducts: "Procedures & Products",
    proceduresAndProductsHint: "Record every billable service or product used in this consultation.",
    itemDescription: "Description",
    itemCategory: "Category",
    categoryProcedure: "Procedure",
    categoryProduct: "Product",
    lineTotal: "Line total",
    consultationTotal: "Consultation total",
    createInvoiceFromConsult: "Create invoice from these items",
    invoiceCreated: "Invoice created",
    // Appointments
    conflictDetected: "Conflict detected",
    overrideConflict: "Override and save anyway (admin)",
    // Search
    searchDiagnosisReport: "Filter reports by diagnosis",
    dateRange: "Date range",
    apply: "Apply",
    reset: "Reset",
    date: "Date",
    // Species
    speciesCatalog: "Species catalog",
    addSpecies: "Add species",
    speciesName: "Species name",
    // Patient extras
    approximateAge: "Approximate age",
    ageInputMode: "Input mode",
    modeDateOfBirth: "Date of birth",
    modeAge: "Age",
    ageHint: "e.g. 3 years 6 months",
    approximately: "approximately",
    years: "years",
    months: "months",
    yearsShort: "y",
    monthsShort: "mo",
    approxAbbrev: "approx.",
    ageOf: "age",
    // Consultation extras
    observations: "Observations",
    observationsHint: "Additional notes and observations for this consultation.",
    // Common
    logOut: "Log out",
    invalidPhone: "Phone can only contain digits and +",
    invalidEmail: "Please enter a valid email address",
    // Male / Female specific
    maleFemale: "Male / Female",
    patient: "Patient",
    cnp: "CNP / PIN",
    cnpExistsWarning: "An owner with this CNP already exists.",
    cnpExistsHint: "Please verify to avoid creating duplicate owners.",
    existingPatients: "Existing patients for this owner",
    keepAndSave: "Save anyway",
    loading: "Loading…",
    viewInvoice: "View invoice",
    // Analytics
    analyticsConsultations: "Consultations",
    analyticsPatientsSeen: "Patients seen",
    analyticsSpeciesTracked: "Species tracked",
    analyticsRevenuePaid: "Revenue (paid)",
    analyticsInvoices: "invoices",
    analyticsLast14Days: "Consultations — last 14 days",
    analyticsSpeciesBreakdown: "Species breakdown",
    analyticsTopReasons: "Top visit reasons",
    analyticsTopDiagnoses: "Top diagnoses",
    analyticsByVet: "Consultations by veterinarian",
    analyticsNoData: "No data.",
    invalidDateRange: "'To' must be after 'From'",
    editUser: "Edit user",
    changePassword: "Change password",
    newPassword: "New password (leave blank to keep)",
    myClinics: "My clinics",
    addClinic: "Add clinic",
    clinicName: "Clinic name",
    createClinic: "Create clinic",
    deleteClinic: "Delete clinic",
    deleteClinicConfirm: "Delete clinic",
    deleteClinicWarn: "All patients, consultations, invoices and appointments in that clinic will be permanently removed.",
    cantDeleteLastClinic: "You cannot delete the last remaining clinic.",
    required: "Required",
    currentClinic: "Current clinic",
    // Archive
    archive: "Archive",
    archiveNav: "Archive",
    archiveHelp: "Archived patient records are kept here and can be restored at any time.",
    archiveEmpty: "There are no archived patients.",
    unarchive: "Restore",
    archived: "Archived",
    archivedPatients: "Archived patients",
    archivePatient: "Archive patient",
    archiveReasonLabel: "Reason",
    archiveReasonDeceased: "Deceased",
    archiveReasonMoved: "Moved / transferred",
    archiveReasonRejected: "Rejected / lost",
    archiveReasonOther: "Other",
    archiveNote: "Note (optional)",
    archiveConfirm: "Move to archive",
    unarchiveConfirm: "Restore patient?",
    showArchived: "Show archived",
    // Idle logout
    idleWarnTitle: "Session expiring",
    idleWarnBody: "You've been inactive. You will be signed out automatically unless you continue.",
    idleStay: "I'm here — keep me signed in",
    // Saved recommendations
    recSaved: "Saved snippets",
    recSaveNew: "Save current as snippet",
    recManage: "Manage",
    recSaveNewTitle: "Save recommendation",
    recManageTitle: "Manage saved recommendations",
    recTitle: "Title",
    recPreview: "Text",
    recNothingToSave: "Write something first",
    // Appointments extras
    editAppointment: "Edit appointment",
    saveChanges: "Save changes",
    consultationDate: "Consultation date",
    changeDate: "Change date",
    // Patient profile image
    photo: "Photo",
    changePhoto: "Change photo",
    removePhoto: "Remove photo",
    // Week label
    week: "Week",
    apptScheduled: "Scheduled",
    apptCanceled: "Canceled",
    // Extended consultation — top level
    examClinicTab: "Clinical exam",
    paraclinicalTab: "Paraclinical investigations",
    enableSection: "Enable",
    printSheet: "Print sheet",
    // Appointments extras
    apptEnableReminder: "Send email reminder day before",
    apptReminderOff: "Reminder off",
    apptReminderOn: "Reminder on",
    apptReminderLangHint: "Reminder will be sent in the current language.",
    // No-results markers
    noBiochemistryRows: "no biochemistry rows",
    // Print
    printing: "Preparing…",
    // Consultation exam titles
    examSumar: "Summary",
    examOftalmologie: "Ophthalmology",
    examOtologie: "Otology",
    examCavitateBucala: "Oral cavity",
    examDermatologie: "Dermatology",
    examNoduliLimfatici: "Lymph nodes",
    examSistemDigestiv: "Digestive system",
    examSistemRespirator: "Respiratory system",
    examSistemCardiovascular: "Cardiovascular system",
    examOsteoarticular: "Musculoskeletal system",
    examSistemNervos: "Central / peripheral nervous system",
    examSistemUrogenital: "Urogenital system",
    // Groups
    gPavilionExtern: "External ear examination",
    gCanalAuditiv: "Ear canal examination",
    gInspectiaGurii: "Inspection of the mouth",
    gDinti: "Teeth",
    gEvaluareStomatologica: "Dental evaluation",
    gPiele: "Skin",
    gBlana: "Coat",
    gUnghii: "Nails",
    gSubmandibulari: "Submandibular",
    gAxilari: "Axillary",
    gPrescapulari: "Prescapular",
    gInghinali: "Inguinal",
    gPoplitei: "Popliteal",
    gSistemDigestiv: "Digestive system",
    gAbdomen: "Abdomen",
    gGlandePerianale: "Perianal glands",
    gCaiSuperioare: "Upper airways",
    gLaringeTrahee: "Larynx & Trachea",
    gPulmoni: "Lungs",
    gSistemOsos: "Osseous system",
    gSistemMuscular: "Muscular system",
    gSistemUrogenital: "Urogenital system",
    gAparatUrinar: "Urinary tract",
    gGenitalMascul: "Male reproductive",
    gGenitalFemela: "Female reproductive",
    gProceduriDiagnostic: "Diagnostic procedures",
    gTestSchirmer: "Schirmer test",
    gTestFluoresceina: "Fluorescein test",
    gTestFirRosu: "Phenol red thread test",
    gAltele: "Other",
    gCilindriUrinari: "Urinary casts",
    gCeluleEpiteliale: "Epithelial cells",
    gCristale: "Crystals",
    gDetalii: "Details",
    gLampaWood: "Wood lamp examination",
    gRaclajCutanat: "Skin scraping",
    gBuletinEcografic: "Ultrasound report",
    gCavitateToracica: "Thoracic cavity",
    gCavitateAbdominala: "Abdominal cavity",
    gBazin: "Pelvis",
    // Paraclinical section titles
    parBiochimie: "Biochemistry",
    parHematologie: "Hematology",
    parElectroliti: "Electrolytes",
    parTesteRapide: "Rapid tests",
    parExamenCopro: "Coproparasitological exam",
    parAnalizeUrina: "Urinalysis",
    parSedimentUrinar: "Urinary sediment",
    parOftalmologie: "Ophthalmology (paraclinical)",
    parOtologie: "Otology (paraclinical)",
    parRaportCitologic: "Cytology report",
    parBuletinDermatologic: "Dermatology report",
    parBuletinEcografic: "Ultrasound report",
    parBuletinRadiologic: "Radiology interpretation report",
    parDozareHormoni: "Hormone panel",
    parImunologie: "Immunology",
    parTesteCoagulare: "Coagulation tests",
    parExamenMicroscopic: "Microscopy",
    parAntibiograma: "Antibiogram",
    // Fields — clinical exam
    fInspectie: "Inspection",
    fAcuitateVizuala: "Visual acuity evaluation",
    fReflexeFoto: "Photopupillary reflexes",
    fOrbite: "Orbits",
    fPleoape: "Eyelids",
    fConjunctiva: "Conjunctiva and nictitating membrane",
    fSclere: "Sclera",
    fCornee: "Cornea",
    fCameraAnterioara: "Anterior chamber",
    fIris: "Iris",
    fCristalin: "Lens",
    fCorpulVitros: "Vitreous body",
    fFundOchi: "Fundus",
    fObservatii: "Observations",
    fSecretie: "Secretions",
    fPalpare: "Palpation",
    fOtoscopie: "Otoscopy",
    fMembranaTimpanica: "Tympanic membrane",
    fBuzeObraji: "Lips and cheeks",
    fOrofaringe: "Oropharynx",
    fMucoasaBucala: "Oral mucosa",
    fValulPalatin: "Soft palate",
    fPlanseulLimba: "Floor of mouth and tongue",
    fDinti: "Teeth",
    fGingii: "Gums",
    fHalitoza: "Halitosis",
    fTartru: "Tartar",
    fGingivita: "Gingivitis",
    fRetractieGingivala: "Gingival recession",
    fEvaluareGenerala: "Overall evaluation",
    fElasticitate: "Elasticity",
    fMiros: "Odor",
    fPrurit: "Pruritus",
    fLampaWood: "Wood lamp examination",
    fStatus: "Status",
    fDetalii: "Details",
    fApetit: "Appetite",
    fPrehensiune: "Prehension",
    fMasticatie: "Mastication",
    fDeglutitie: "Deglutition",
    fVoma: "Vomiting",
    fTranzitGI: "GI transit",
    fFecale: "Feces",
    fAuscultatie: "Auscultation",
    fPercutie: "Percussion",
    fFrecventaResp: "Respiratory rate",
    fFrecventaCard: "Heart rate",
    fTensiune: "Blood pressure",
    fPuls: "Pulse",
    fGradSuflu: "Murmur grade",
    fTrilPrecordial: "Precordial thrill",
    fTipSuflu: "Murmur type",
    fLocalizareSuflu: "Murmur location",
    fAplomb: "Stance",
    fStareConstiinta: "Level of consciousness",
    fCoordonare: "Coordination of movements",
    fComportament: "Behavior",
    fReflexe: "Reflexes",
    fTipProcedura: "Procedure type",
    fMictiune: "Urination",
    fUrina: "Urine",
    fVezica: "Bladder",
    fPenis: "Penis",
    fTesticule: "Testicles",
    fProstata: "Prostate",
    fVulva: "Vulva",
    fCicluCalduri: "Estrus cycle",
    // Paraclinical fields
    fConsistentaCulMiros: "Consistency, color, odor",
    fMetodaLucru: "Method",
    fTestFlotatie: "Flotation test",
    fRezultat: "Result",
    fStripUrina: "Urine strip",
    fDataRecoltare: "Date/Time of collection",
    fDataExaminare: "Date/Time of examination",
    fDepozitare: "Sample storage/transport",
    fConditii: "Collection conditions",
    fCuloare: "Color",
    fTransparenta: "Transparency",
    fDensitate: "Specific gravity",
    fHemoglobinaUr: "Hemoglobin",
    fEritrociteIntacte: "Intact erythrocytes",
    fUrobilinogen: "Urobilinogen",
    fBilirubinaUr: "Bilirubin",
    fProteinaUr: "Protein",
    fNitriti: "Nitrites",
    fCorpiCetonici: "Ketone bodies",
    fAcidAscorbic: "Ascorbic acid",
    fGlucozaUr: "Glucose (GLU)",
    fPh: "pH",
    fLeucociteUr: "Leukocytes",
    fHialini: "Hyaline",
    fGranulari: "Granular",
    fDeGrasime: "Fatty",
    fEpiteliali: "Epithelial",
    fEritrocitari: "Erythrocytic",
    fLeucocitari: "Leukocytic",
    fLeucocite: "Leukocytes",
    fEritrocite: "Erythrocytes",
    fPicaturiGrasime: "Fat droplets",
    fCilindriHematici: "Hematic casts",
    fCilindriBiliari: "Biliary casts",
    fScuamoase: "Squamous",
    fTranzitionale: "Transitional",
    fTubulareRenale: "Renal tubular",
    fNeoplazice: "Neoplastic",
    fFosfatiAlk: "Phosphates (neutral/alkaline urine)",
    fUrati: "Urates (acidic/neutral)",
    fOxalatiCa: "Ca oxalates (acidic/neutral/alkaline)",
    fCarbonatiCa: "Ca carbonates (neutral/alkaline)",
    fUratiAmoniu: "Ammonium urates (acidic/neutral)",
    fBilirubinaCr: "Bilirubin (acidic)",
    fLeucina: "Leucine (acidic)",
    fTirozina: "Tyrosine (acidic)",
    fCisteina: "Cystine (acidic)",
    fSulfatiCa: "Ca sulfates",
    fFosfatiCa: "Ca phosphates",
    fAcidUric: "Uric acid",
    fMucus: "Mucus",
    fSpermatozoizi: "Sperm",
    fBacterii: "Bacteria",
    fHife: "Hyphae",
    fParaziti: "Parasites",
    fGreutate: "Weight",
    fHematii: "Red blood cells",
    fMicroalbumina: "Microalbumin",
    fCalciu: "Calcium",
    fCreatinina: "Creatinine",
    fProtCreat: "Protein : Creatinine ratio",
    fEcografieOculara: "Ocular ultrasound",
    fTonometrie: "Tonometry",
    fOftalmoscopie: "Ophthalmoscopy",
    fSchirmerStgCant: "Schirmer left eye quantitative",
    fSchirmerDrCant: "Schirmer right eye quantitative",
    fSchirmerStgCalit: "Schirmer left eye qualitative",
    fSchirmerDrCalit: "Schirmer right eye qualitative",
    fFluoresceinaStg: "Fluorescein left eye",
    fFluoresceinaDr: "Fluorescein right eye",
    fFirRosuStg: "Phenol red thread left eye",
    fFirRosuDr: "Phenol red thread right eye",
    fCitologic: "Cytology exam",
    fAntibiograma: "Antibiogram",
    fParazitologic: "Parasitology exam",
    fMicologic: "Mycology exam",
    fTrichograma: "Trichogram",
    fBacteriologic: "Bacteriology exam",
    fRezultatWood: "Wood lamp result",
    fConcluziiWood: "Wood lamp conclusions",
    fLocalizare: "Location",
    fRezultatRaclaj: "Skin scraping result",
    fConcluziiRaclaj: "Skin scraping conclusions",
    fRecoltareSecretie: "Ear secretion sampling",
    fRezultatSecretie: "Ear secretion result",
    fAspectGeneral: "General appearance",
    fMomentAparitiei: "Onset",
    fDimensiune: "Size",
    fConsistenta: "Consistency",
    fSemneClinice: "Clinical signs",
    fLnSuperficiale: "Superficial lymph nodes",
    fRezultateTeste: "Complementary test results",
    fModRecoltare: "Sampling method",
    fMetodaColorare: "Staining method",
    fDescriereCit: "Cytological description",
    fDiagnostic: "Diagnosis",
    fExamenClinic: "Clinical examination",
    fDateLeziune: "Lesion details",
    fTratamenteAnterioare: "Previous treatments",
    fModLucru: "Working method",
    fRezultateProceduri: "Results — diagnostic procedures",
    fRecomandari: "Recommendations",
    fLimfonoduri: "Lymph nodes",
    fCord: "Heart",
    fPulmoni: "Lungs",
    fStomac: "Stomach",
    fFicat: "Liver",
    fColecist: "Gallbladder",
    fSplina: "Spleen",
    fPancreas: "Pancreas",
    fIntGros: "Large intestine",
    fIntSubt: "Small intestine",
    fRinichi: "Kidney",
    fUter: "Uterus",
    fOvar: "Ovary",
    fIndicatie: "Indication",
    fTehnica: "Technique",
    fInterpretareRad: "Radiologic interpretation",
    fCortizol: "Cortisol",
    fT3: "T3",
    fT4: "T4",
    fTSH: "TSH",
    fLipazaSpecifica: "Specific lipase",
    fProgesteron: "Progesterone",
    fTestosteron: "Testosterone",
    fFSH: "FSH",
    fLH: "LH",
    fProlactina: "Prolactin",
    fProbaColectata: "Sample collected",
    fInterpretare: "Interpretation",
    fSensibilitate: "Sensitive to",
    fAdaugaObs: "Add observations",
    fCategoryImunologie: "Immunology",
    fCategoryCoagulare: "Coagulation",
  },
  ro: {
    dashboard: "Panou",
    patients: "Pacienți",
    reports: "Rapoarte",
    settings: "Setări",
    appointments: "Programări",
    invoices: "Facturi",
    analytics: "Statistici",
    ownerPortal: "Portal proprietar",
    logout: "Deconectare",
    signIn: "Autentificare",
    signInHint: "Introduceți datele de acces ale clinicii.",
    email: "Email",
    password: "Parolă",
    signingIn: "Se autentifică…",
    demoCredentials: "Încercați demo-ul:",
    forgotPassword: "Ați uitat parola?",
    noAccountYet: "Nu ai încă un cont?",
    createAccount: "Înregistrare",
    signingUp: "Se creează contul…",
    fullName: "Nume complet",
    passwordMinChars: "Minim 6 caractere",
    registerSuccessTitle: "Verifică-ți email-ul",
    registerSuccessBody: "Am trimis un link de confirmare pe adresa ta. Apasă-l pentru a valida email-ul, apoi așteaptă ca administratorul să îți atribuie rolul și clinica.",
    verifyingEmail: "Se verifică adresa de email…",
    emailVerifiedTitle: "Email confirmat",
    emailVerifiedBody: "Contul tău așteaptă ca administratorul să îți atribuie rolul și clinica. Vei primi un email de îndată ce e gata.",
    emailVerifyFailedTitle: "Verificare eșuată",
    backToLogin: "Înapoi la autentificare",
    resendVerification: "Retrimite email-ul de confirmare",
    registerClinic: "Înregistrează-ți clinica",
    goodEvening: "Bine ați revenit",
    searchPlaceholder: "Căutați pacient, proprietar sau telefon…",
    searchHint: "Apăsați ⌘K oricând",
    quickActions: "Acțiuni rapide",
    newPatient: "Pacient nou",
    newConsultation: "Consultație nouă",
    selectPatientForConsult: "Caută și selectează pacientul pentru această consultație.",
    exportConsults: "Export consultații",
    recentPatients: "Pacienți recenți",
    recentConsultations: "Consultații recente",
    metricPatients: "Pacienți înregistrați",
    metricConsultsToday: "Consultații săptămâna aceasta",
    metricPendingDrafts: "Consultații draft",
    owner: "Proprietar",
    species: "Specie",
    breed: "Rasă",
    sex: "Sex",
    birthDate: "Data nașterii",
    neutered: "Sterilizat",
    age: "Vârstă",
    consultations: "Consultații",
    attachments: "Documente",
    addAttachment: "Adaugă document",
    deletePatient: "Șterge pacient",
    visitReasons: "Motiv vizită",
    privateNotes: "Note private (nu se trimit)",
    anamnesis: "Istoric / Anamneză",
    consultationReport: "Fișă consultație",
    view: "Vizualizează",
    clinicalExamination: "Examen clinic",
    generalExam: "Examinare generală",
    temperature: "Temperatură",
    weight: "Greutate",
    clinicalExam: "Examen clinic",
    labInvestigations: "Investigații de laborator",
    biochemistry: "Biochimie",
    cbc: "Hemoleucogramă completă",
    parameter: "Parametru",
    result: "Rezultat",
    unit: "Unitate",
    referenceRange: "Interval de referință",
    diagnosis: "Diagnostic",
    treatment: "Tratament",
    recommendations: "Recomandări",
    attendingVet: "Medic curant",
    autosave: "Salvat automat",
    saving: "Se salvează…",
    save: "Salvează",
    saveFinal: "Salvează ca final",
    downloadPdf: "Descarcă PDF",
    emailOwner: "Trimite proprietarului",
    delete: "Șterge",
    cancel: "Renunță",
    translateFieldsRo: "Traduce în română",
    translateFieldsEn: "Traduce în engleză",
    translating: "Se traduce…",
    filters: "Filtre",
    dateFrom: "De la",
    dateTo: "Până la",
    veterinarian: "Medic veterinar",
    all: "Toate",
    exportXlsx: "Export .xlsx",
    invoiceNumber: "Nr.",
    invoiceStatus: "Status",
    invoiceIssued: "Emisă",
    dueDate: "Scadență",
    undiagnosedYet: "Nediagnosticat încă",
    invoiceTotal: "Total",
    newInvoice: "Factură nouă",
    invoiceStatusDraft: "Draft",
    invoiceStatusUnpaid: "Neachitată",
    invoiceStatusSent: "Trimisă",
    invoiceStatusPaid: "Plătită",
    invoiceStatusVoid: "Anulată",
    description: "Descriere",
    qty: "Cant.",
    unitPrice: "Preț unitar (cu TVA)",
    taxPct: "TVA %",
    currency: "Monedă",
    subtotal: "Subtotal",
    tax: "TVA",
    createInvoice: "Creează factură",
    markPaid: "Marchează plătită",
    voidInvoice: "Anulează",
    noInvoices: "Nu există facturi încă.",
    clinicProfile: "Profil clinică",
    users: "Utilizatori",
    pendingUsers: "Utilizatori în așteptare",
    noPendingUsers: "Niciun utilizator în așteptare.",
    approve: "Aprobă",
    reject: "Respinge",
    approveUser: "Aprobă utilizator",
    userApproved: "Utilizator aprobat.",
    userRejected: "Utilizator respins.",
    confirmReject: "Respinge acest utilizator?",
    selectClinic: "Selectați o clinică.",
    clinic: "Clinică",
    actions: "Acțiuni",
    customVisitReasons: "Motive de vizită",
    referenceRanges: "Intervale de referință",
    cui: "CUI",
    regCom: "Nr. Reg. Com.",
    iban: "IBAN",
    bankName: "Banca",
    invoiceSeries: "Seria facturii",
    addRow: "Adaugă rând",
    remove: "Elimină",
    yes: "Da",
    no: "Nu",
    male: "Mascul",
    female: "Femelă",
    dog: "Câine",
    cat: "Pisică",
    other: "Alt animal",
    role: "Rol",
    admin: "Administrator",
    veterinarianRole: "Medic veterinar",
    assistant: "Asistent",
    name: "Nume",
    phone: "Telefon",
    address: "Adresă",
    saved: "Salvat",
    saveClinicInfo: "Salvează",
    logo: "Logo",
    uploadLogo: "Încarcă logo",
    replaceLogo: "Înlocuiește logo",
    minValue: "Min",
    maxValue: "Max",
    category: "Categorie",
    fullName: "Nume complet",
    createPatient: "Adaugă pacient",
    createUser: "Adaugă utilizator",
    addReason: "Adaugă motiv",
    saveRefRanges: "Salvează intervalele",
    noResults: "Niciun rezultat încă.",
    createFirst: "Creați prima înregistrare pentru a începe.",
    weekOf: "Săptămâna",
    monthView: "Lună",
    weekView: "Săptămână",
    dayView: "Zi",
    today: "Azi",
    newAppointment: "Programare nouă",
    reason: "Motiv",
    dateTime: "Data și ora",
    schedule: "Programează",
    noAppointments: "Fără programări",
    completed: "Finalizată",
    noShow: "Neprezentat",
    speciesLabel: "Specie",
    speciesCustomPlaceholder: "Introduceți o specie (ex. iepure, papagal)",
    // Consultation attachments
    consultAttachments: "Documente consultație",
    consultAttachmentsHint: "Fișierele adăugate aici aparțin doar acestei consultații.",
    uploadFiles: "Încarcă fișiere",
    uploading: "Se încarcă…",
    dropOrClick: "Trage fișiere aici sau apasă pentru a alege",
    fileTypes: "Imagini (JPEG, PNG) și PDF-uri, până la 25MB fiecare.",
    // Diagnoses
    searchOrCreateDiagnosis: "Caută sau creează un diagnostic…",
    createDiagnosis: "Adaugă diagnostic",
    diagnosisNotes: "Note diagnostic (text liber)",
    selectedDiagnoses: "Diagnostice selectate",
    filterDiagnosis: "Diagnostic",
    diagnosisStats: "Statistici diagnostice",
    groupBy: "Grupare",
    groupByDiagnosis: "După diagnostic",
    groupByMonth: "După lună",
    groupBySpecies: "După specie",
    groupByVet: "După medic",
    totalCases: "Total cazuri",
    // Billing
    proceduresAndProducts: "Proceduri și produse",
    proceduresAndProductsHint: "Înregistrați toate serviciile și produsele facturabile din această consultație.",
    itemDescription: "Descriere",
    itemCategory: "Categorie",
    categoryProcedure: "Procedură",
    categoryProduct: "Produs",
    lineTotal: "Valoare",
    consultationTotal: "Total consultație",
    createInvoiceFromConsult: "Emite factură din aceste articole",
    invoiceCreated: "Factură creată",
    // Appointments
    conflictDetected: "Conflict detectat",
    overrideConflict: "Salvează totuși (administrator)",
    // Search
    searchDiagnosisReport: "Filtrează rapoartele după diagnostic",
    dateRange: "Interval",
    apply: "Aplică",
    reset: "Resetează",
    date: "Data",
    // Species
    speciesCatalog: "Catalog specii",
    addSpecies: "Adaugă specie",
    speciesName: "Nume specie",
    // Patient extras
    approximateAge: "Vârstă aproximativă",
    ageInputMode: "Mod introducere",
    modeDateOfBirth: "Data nașterii",
    modeAge: "Vârstă",
    ageHint: "ex. 3 ani 6 luni",
    approximately: "aproximativ",
    years: "ani",
    months: "luni",
    yearsShort: "a",
    monthsShort: "l",
    approxAbbrev: "aprox.",
    ageOf: "vârstă",
    // Consultation extras
    observations: "Observații",
    observationsHint: "Note și observații suplimentare pentru această consultație.",
    // Common
    logOut: "Ieșire din cont",
    invalidPhone: "Telefonul poate conține doar cifre și „+”",
    invalidEmail: "Introduceți o adresă de email validă",
    maleFemale: "Mascul / Femelă",
    patient: "Pacient",
    cnp: "CNP",
    cnpExistsWarning: "Un proprietar cu acest CNP există deja.",
    cnpExistsHint: "Verificați pentru a evita duplicarea proprietarilor.",
    existingPatients: "Pacienți existenți pentru acest proprietar",
    keepAndSave: "Salvează oricum",
    loading: "Se încarcă…",
    viewInvoice: "Vezi factura",
    // Analytics
    analyticsConsultations: "Consultații",
    analyticsPatientsSeen: "Pacienți consultați",
    analyticsSpeciesTracked: "Specii înregistrate",
    analyticsRevenuePaid: "Venituri (încasate)",
    analyticsInvoices: "facturi",
    analyticsLast14Days: "Consultații — ultimele 14 zile",
    analyticsSpeciesBreakdown: "Distribuție pe specii",
    analyticsTopReasons: "Cele mai frecvente motive",
    analyticsTopDiagnoses: "Cele mai frecvente diagnostice",
    analyticsByVet: "Consultații pe medic",
    analyticsNoData: "Nu există date.",
    invalidDateRange: "Data „Până la” trebuie să fie după „De la”",
    editUser: "Editează utilizator",
    changePassword: "Schimbă parola",
    newPassword: "Parolă nouă (lasă gol pentru a păstra)",
    myClinics: "Clinicile mele",
    addClinic: "Adaugă clinică",
    clinicName: "Nume clinică",
    createClinic: "Creează clinica",
    deleteClinic: "Șterge clinica",
    deleteClinicConfirm: "Ștergeți clinica",
    deleteClinicWarn: "Toți pacienții, consultațiile, facturile și programările din această clinică vor fi eliminate definitiv.",
    cantDeleteLastClinic: "Nu puteți șterge ultima clinică rămasă.",
    required: "Obligatoriu",
    currentClinic: "Clinica curentă",
    // Archive
    archive: "Arhivează",
    archiveNav: "Arhivă",
    archiveHelp: "Aici sunt păstrate fișele pacienților arhivați, gata de restaurare oricând.",
    archiveEmpty: "Nu există pacienți arhivați.",
    unarchive: "Restaurează",
    archived: "Arhivat",
    archivedPatients: "Pacienți arhivați",
    archivePatient: "Arhivează pacientul",
    archiveReasonLabel: "Motiv",
    archiveReasonDeceased: "Decedat",
    archiveReasonMoved: "Mutat / transferat",
    archiveReasonRejected: "Refuzat / pierdut",
    archiveReasonOther: "Alt motiv",
    archiveNote: "Notă (opțional)",
    archiveConfirm: "Mută în arhivă",
    unarchiveConfirm: "Restaurează pacientul?",
    showArchived: "Arată arhivați",
    // Idle logout
    idleWarnTitle: "Sesiunea expiră",
    idleWarnBody: "Ați fost inactiv un timp. Veți fi deconectat automat dacă nu continuați activitatea.",
    idleStay: "Sunt aici — păstrează-mă conectat",
    // Saved recommendations
    recSaved: "Recomandări salvate",
    recSaveNew: "Salvează textul curent",
    recManage: "Gestionează",
    recSaveNewTitle: "Salvează o recomandare",
    recManageTitle: "Gestionează recomandările salvate",
    recTitle: "Titlu",
    recPreview: "Text",
    recNothingToSave: "Scrieți întâi ceva",
    // Appointments extras
    editAppointment: "Editează programarea",
    saveChanges: "Salvează modificările",
    consultationDate: "Data consultației",
    changeDate: "Schimbă data",
    // Patient profile image
    photo: "Fotografie",
    changePhoto: "Schimbă fotografia",
    removePhoto: "Elimină fotografia",
    // Week label
    week: "Săptămâna",
    apptScheduled: "Programată",
    apptCanceled: "Anulată",
    // Extended consultation — top level
    examClinicTab: "Examen clinic",
    paraclinicalTab: "Investigații paraclinice",
    enableSection: "Activează",
    printSheet: "Printează fișa",
    // Appointments extras
    apptEnableReminder: "Trimite email de reamintire cu o zi înainte",
    apptReminderOff: "Reamintire dezactivată",
    apptReminderOn: "Reamintire activată",
    apptReminderLangHint: "Reamintirea se va trimite în limba curentă.",
    // No-results markers
    noBiochemistryRows: "no biochemistry rows",
    printing: "Se pregătește…",
    examSumar: "Sumar",
    examOftalmologie: "Oftalmologie",
    examOtologie: "Otologie",
    examCavitateBucala: "Cavitatea bucală",
    examDermatologie: "Dermatologie",
    examNoduliLimfatici: "Noduli limfatici",
    examSistemDigestiv: "Sistem digestiv",
    examSistemRespirator: "Sistem respirator",
    examSistemCardiovascular: "Sistem cardiovascular",
    examOsteoarticular: "Sistem osteoarticular & muscular",
    examSistemNervos: "Sistem nervos central / periferic",
    examSistemUrogenital: "Sistem urogenital",
    gPavilionExtern: "Examinarea pavilionului extern",
    gCanalAuditiv: "Examinarea canalului auditiv",
    gInspectiaGurii: "Inspecția gurii",
    gDinti: "Dinți",
    gEvaluareStomatologica: "Evaluare stomatologică",
    gPiele: "Piele",
    gBlana: "Blană",
    gUnghii: "Unghii",
    gSubmandibulari: "Submandibulari",
    gAxilari: "Axilari",
    gPrescapulari: "Prescapulari",
    gInghinali: "Inghinali",
    gPoplitei: "Poplitei",
    gSistemDigestiv: "Sistem digestiv",
    gAbdomen: "Abdomen",
    gGlandePerianale: "Glande perianale",
    gCaiSuperioare: "Căile respiratorii superioare",
    gLaringeTrahee: "Laringe & Trahee",
    gPulmoni: "Pulmoni",
    gSistemOsos: "Sistem osos",
    gSistemMuscular: "Sistem muscular",
    gSistemUrogenital: "Sistem urogenital",
    gAparatUrinar: "Aparatul urinar",
    gGenitalMascul: "Aparat genital mascul",
    gGenitalFemela: "Aparat genital femelă",
    gProceduriDiagnostic: "Proceduri de diagnostic",
    gTestSchirmer: "Test Schirmer",
    gTestFluoresceina: "Testare Fluoresceină",
    gTestFirRosu: "Test cu fir roșu de fenol",
    gAltele: "Altele",
    gCilindriUrinari: "Cilindri urinari",
    gCeluleEpiteliale: "Celule epiteliale",
    gCristale: "Cristale",
    gDetalii: "Detalii",
    gLampaWood: "Examinare Lampă Wood",
    gRaclajCutanat: "Raclaj cutanat",
    gBuletinEcografic: "Buletin ecografic",
    gCavitateToracica: "Cavitatea toracică",
    gCavitateAbdominala: "Cavitatea abdominală",
    gBazin: "Bazin",
    parBiochimie: "Biochimie",
    parHematologie: "Hematologie",
    parElectroliti: "Electroliți",
    parTesteRapide: "Teste rapide",
    parExamenCopro: "Examen coproparazitologic",
    parAnalizeUrina: "Analize urină",
    parSedimentUrinar: "Sediment urinar",
    parOftalmologie: "Oftalmologie (paraclinic)",
    parOtologie: "Otologie (paraclinic)",
    parRaportCitologic: "Raport citologic",
    parBuletinDermatologic: "Buletin dermatologic",
    parBuletinEcografic: "Buletin ecografic",
    parBuletinRadiologic: "Buletin interpretare radiologică",
    parDozareHormoni: "Dozare hormoni",
    parImunologie: "Imunologie",
    parTesteCoagulare: "Teste de coagulare",
    parExamenMicroscopic: "Examen microscopic",
    parAntibiograma: "Antibiogramă",
    fInspectie: "Inspecție",
    fAcuitateVizuala: "Evaluarea acuității vizuale",
    fReflexeFoto: "Reflexe fotopupilare",
    fOrbite: "Orbite",
    fPleoape: "Pleoape",
    fConjunctiva: "Conjunctiva și membrana nictitantă",
    fSclere: "Sclere",
    fCornee: "Cornee",
    fCameraAnterioara: "Cameră anterioară",
    fIris: "Iris",
    fCristalin: "Cristalin",
    fCorpulVitros: "Corpul vitros",
    fFundOchi: "Fundul de ochi",
    fObservatii: "Observații",
    fSecretie: "Secreție",
    fPalpare: "Palpare",
    fOtoscopie: "Otoscopie",
    fMembranaTimpanica: "Examinarea membranei timpanice",
    fBuzeObraji: "Buze și obraji",
    fOrofaringe: "Orofaringe",
    fMucoasaBucala: "Mucoasa bucală",
    fValulPalatin: "Vălul palatin",
    fPlanseulLimba: "Planșeul cavității bucale și limba",
    fDinti: "Dinți",
    fGingii: "Gingii",
    fHalitoza: "Halitoză",
    fTartru: "Tartru",
    fGingivita: "Gingivită",
    fRetractieGingivala: "Retracție gingivală",
    fEvaluareGenerala: "Evaluare generală",
    fElasticitate: "Elasticitate",
    fMiros: "Miros",
    fPrurit: "Prurit",
    fLampaWood: "Examinare Lampă Wood",
    fStatus: "Status",
    fDetalii: "Detalii",
    fApetit: "Apetit",
    fPrehensiune: "Prehensiune",
    fMasticatie: "Masticație",
    fDeglutitie: "Deglutiție",
    fVoma: "Vomă",
    fTranzitGI: "Tranzit gastrointestinal",
    fFecale: "Fecale",
    fAuscultatie: "Auscultație",
    fPercutie: "Percuție",
    fFrecventaResp: "Frecvență respiratorie",
    fFrecventaCard: "Frecvență cardiacă",
    fTensiune: "Tensiune arterială",
    fPuls: "Puls",
    fGradSuflu: "Grad Suflu",
    fTrilPrecordial: "Tril precordial",
    fTipSuflu: "Tip Suflu",
    fLocalizareSuflu: "Localizare Suflu",
    fAplomb: "Aplomb",
    fStareConstiinta: "Stare de conștiență",
    fCoordonare: "Coordonarea mișcărilor",
    fComportament: "Comportament",
    fReflexe: "Reflexe",
    fTipProcedura: "Tip Procedură",
    fMictiune: "Micțiune",
    fUrina: "Urină",
    fVezica: "Vezică urinară",
    fPenis: "Penis",
    fTesticule: "Testicule",
    fProstata: "Prostată",
    fVulva: "Vulvă",
    fCicluCalduri: "Ciclu Călduri",
    fConsistentaCulMiros: "Consistență, culoare, miros",
    fMetodaLucru: "Metodă de lucru",
    fTestFlotatie: "Testul flotației",
    fRezultat: "Rezultat",
    fStripUrina: "Strip Urină",
    fDataRecoltare: "Data/Ora recoltării probei",
    fDataExaminare: "Data/Ora examinării probei",
    fDepozitare: "Depozitarea/Transportul probei",
    fConditii: "Condiții de recoltare",
    fCuloare: "Culoare",
    fTransparenta: "Transparență",
    fDensitate: "Densitate specifică",
    fHemoglobinaUr: "Hemoglobină",
    fEritrociteIntacte: "Eritrocite intacte",
    fUrobilinogen: "Urobilinogen",
    fBilirubinaUr: "Bilirubină",
    fProteinaUr: "Proteină",
    fNitriti: "Nitriți",
    fCorpiCetonici: "Corpi cetonici",
    fAcidAscorbic: "Acid ascorbic",
    fGlucozaUr: "Glucoză (GLU)",
    fPh: "pH",
    fLeucociteUr: "Leucocite",
    fHialini: "Hialini",
    fGranulari: "Granulari",
    fDeGrasime: "De grăsime",
    fEpiteliali: "Epiteliali",
    fEritrocitari: "Eritrocitari",
    fLeucocitari: "Leucocitari",
    fLeucocite: "Leucocite",
    fEritrocite: "Eritrocite",
    fPicaturiGrasime: "Picături de grăsime",
    fCilindriHematici: "Cilindri Hematici",
    fCilindriBiliari: "Cilindri Biliari",
    fScuamoase: "Scuamoase",
    fTranzitionale: "Tranziționale",
    fTubulareRenale: "Tubulare renale",
    fNeoplazice: "Neoplazice",
    fFosfatiAlk: "Fosfați (urină neutră / alcalină)",
    fUrati: "Urați (acidă / neutră)",
    fOxalatiCa: "Oxalați de Ca (acidă / neutră / alcalină)",
    fCarbonatiCa: "Carbonați de Ca (neutră / alcalină)",
    fUratiAmoniu: "Urați de amoniu (acidă / neutră)",
    fBilirubinaCr: "Bilirubină (acidă)",
    fLeucina: "Leucină (acidă)",
    fTirozina: "Tirozină (acidă)",
    fCisteina: "Cisteină (acidă)",
    fSulfatiCa: "Sulfați de Ca",
    fFosfatiCa: "Fosfați de Ca",
    fAcidUric: "Acid Uric",
    fMucus: "Mucus",
    fSpermatozoizi: "Spermatozoizi",
    fBacterii: "Bacterii",
    fHife: "Hife",
    fParaziti: "Paraziți",
    fGreutate: "Greutate",
    fHematii: "Hematii",
    fMicroalbumina: "Microalbumină",
    fCalciu: "Calciu",
    fCreatinina: "Creatinină",
    fProtCreat: "Raport Proteină : Creatinină",
    fEcografieOculara: "Ecografie oculară",
    fTonometrie: "Tonometrie",
    fOftalmoscopie: "Oftalmoscopie",
    fSchirmerStgCant: "Test Schirmer ochi stâng cantitativ",
    fSchirmerDrCant: "Test Schirmer ochi drept cantitativ",
    fSchirmerStgCalit: "Test Schirmer ochi stâng calitativ",
    fSchirmerDrCalit: "Test Schirmer ochi drept calitativ",
    fFluoresceinaStg: "Test Fluoresceină ochi stâng",
    fFluoresceinaDr: "Test Fluoresceină ochi drept",
    fFirRosuStg: "Test cu fir roșu de fenol ochi stâng",
    fFirRosuDr: "Test cu fir roșu de fenol ochi drept",
    fCitologic: "Examen citologic",
    fAntibiograma: "Antibiogramă",
    fParazitologic: "Examen parazitologic",
    fMicologic: "Examen micologic",
    fTrichograma: "Trichogramă",
    fBacteriologic: "Examen bacteriologic",
    fRezultatWood: "Rezultate — Lampă Wood",
    fConcluziiWood: "Concluzii — Lampă Wood",
    fLocalizare: "Localizare",
    fRezultatRaclaj: "Rezultate — raclaj cutanat",
    fConcluziiRaclaj: "Concluzii — raclaj cutanat",
    fRecoltareSecretie: "Recoltare secreție auriculară",
    fRezultatSecretie: "Rezultat secreție auriculară",
    fAspectGeneral: "Aspect general",
    fMomentAparitiei: "Momentul apariției",
    fDimensiune: "Dimensiune",
    fConsistenta: "Consistență",
    fSemneClinice: "Semne clinice",
    fLnSuperficiale: "Ln superficiale",
    fRezultateTeste: "Rezultate teste complementare",
    fModRecoltare: "Mod de recoltare",
    fMetodaColorare: "Metodă de colorare",
    fDescriereCit: "Descriere citologică",
    fDiagnostic: "Diagnostic",
    fExamenClinic: "Examen clinic",
    fDateLeziune: "Date despre leziune",
    fTratamenteAnterioare: "Tratamente anterioare",
    fModLucru: "Mod de lucru",
    fRezultateProceduri: "Rezultate — proceduri de diagnostic",
    fRecomandari: "Recomandări",
    fLimfonoduri: "Limfonoduri",
    fCord: "Cord",
    fPulmoni: "Pulmoni",
    fStomac: "Stomac",
    fFicat: "Ficat",
    fColecist: "Colecist",
    fSplina: "Splină",
    fPancreas: "Pancreas",
    fIntGros: "Intestinul gros",
    fIntSubt: "Intestinul subțire",
    fRinichi: "Rinichi",
    fUter: "Uter",
    fOvar: "Ovar",
    fIndicatie: "Indicație",
    fTehnica: "Tehnică",
    fInterpretareRad: "Interpretare radiologică",
    fCortizol: "Cortizol",
    fT3: "T3",
    fT4: "T4",
    fTSH: "TSH",
    fLipazaSpecifica: "Lipaza specifică",
    fProgesteron: "Progesteron",
    fTestosteron: "Testosteron",
    fFSH: "FSH",
    fLH: "LH",
    fProlactina: "Prolactina",
    fProbaColectata: "Probă colectată",
    fInterpretare: "Interpretare",
    fSensibilitate: "Sensibilitate la",
    fAdaugaObs: "Adaugă observații",
    fCategoryImunologie: "Imunologie",
    fCategoryCoagulare: "Coagulare",
  },
};

export function t(lang, key) {
  return dict[lang]?.[key] ?? dict.en[key] ?? key;
}
